import { render, staticRenderFns } from "./StudySelector.vue?vue&type=template&id=06c5e3ea&scoped=true&"
import script from "./StudySelector.vue?vue&type=script&lang=js&"
export * from "./StudySelector.vue?vue&type=script&lang=js&"
import style0 from "./StudySelector.vue?vue&type=style&index=0&id=06c5e3ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5e3ea",
  null
  
)

export default component.exports